import React from 'react';
import { useSearchBar } from '../hooks/useSearchBar';

type SuffixWrapperProps = { children: React.ReactNode };

const SuffixWrapper = ({ children }: SuffixWrapperProps) => {
	const { blockClass } = useSearchBar();

	return (
		<div
			className={`suffixWrapper suffixWrapper--${blockClass} vtex-store-components-3-x-suffixWrapper vtex-store-components-3-x-suffixWrapper--${blockClass} flex h-100`}
		>
			{children}
		</div>
	);
};

export default SuffixWrapper;
